import { FC, memo } from 'react';

import { Advantage, Advantages } from '@/components/Advantages';
import { ImageComponent } from '@/components/Image';
import useEstonia from '@/hooks/estonia';
import { useCommonStore } from '@/store';

import {
  ScBannerTitle,
  ScContent,
  ScRegBanner,
  ScRegBannerContainer,
  ScRegFormPlug,
  ScRegistrationBannerProps,
} from './styled';
import { ScContainer } from '@/styles/common';

export interface RegSlideProps extends ScRegistrationBannerProps {
  characterImage?: string;
  advantages: Advantage[];
  title?: string;
  titleColor?: string;
  backgroundDesktop?: string;
  backgroundMobile?: string;
  priority: boolean;
  loading: 'eager' | 'lazy';
}

export const RegBanner: FC<RegSlideProps> = memo(
  ({
    characterImage,
    title,
    titleColor,
    advantages,
    backgroundDesktop,
    backgroundMobile,
    priority,
    loading,
    ...props
  }) => {
    const { isEstonia } = useEstonia();
    const isMobileDevice = useCommonStore.use.isMobileDevice();

    return (
      <ScRegBanner {...props}>
        <ImageComponent
          src={(isMobileDevice ? backgroundMobile : backgroundDesktop) || ''}
          className="slider-bg"
          alt="slider bg"
          fill
          priority={priority}
          loading={loading}
        />
        <ScContainer relative>
          <ScRegBannerContainer isEstonia={isEstonia}>
            <ScRegFormPlug />
            <ScContent>
              <ScBannerTitle titleColor={titleColor}>{title}</ScBannerTitle>
              <Advantages advantages={advantages} />
              <div className="character-image">
                <ImageComponent
                  src={characterImage || ''}
                  className="characters"
                  alt="characters"
                  fill
                  priority
                  loading="eager"
                />
              </div>
            </ScContent>
          </ScRegBannerContainer>
        </ScContainer>
      </ScRegBanner>
    );
  }
);
